module.exports = __webpack_public_path__ + "img/blank.1d40c65e.jpg";